module.exports = __webpack_public_path__ + "img/task-2-l.6f8c663a.png";